import React from 'react';
import './App.css';
import MuiTimePicker from './MuiTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

function App() {
  return (
    <div className="App">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MuiTimePicker />
      </LocalizationProvider>
    </div>
  );
}

export default App;
